export default __webpack_public_path__ + "static/media/raise-hand.25632abb.svg";